module.exports = __webpack_public_path__ + "static/media/StrangerDanger.0684caee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forskar-fredag/StrangerDanger.jpg
// module id = 202
// module chunks = 0